import React from 'react';
import classNames from 'classnames';

import WpIcon from 'Wpds/components/icon/WpIcon';

import './GoalIcon.scss';
import { GoalIcons } from 'Shared/constants/types';

type Size = 'sm' | 'md' | 'lg' | 'xl';

type Props = {
  icon: string;
  status: string;
  size?: Size;
  rounded?: boolean;
};

const GoalIcon = ({ icon, status, size = 'lg', rounded = false }: Props) => {
  const iconSize = () => {
    if (size === 'sm') return 'md';
    if (size === 'xl') return 'lg';
    return size;
  };

  const classNamePrefix = 'GoalIcon';
  const classes = classNames(
    classNamePrefix,
    `${classNamePrefix}--${status}`,
    `${classNamePrefix}--${size}`,
    rounded ? `${classNamePrefix}--rounded` : ''
  );

  return (
    <div className={classes}>
      <WpIcon name={icon || GoalIcons.ice_cream} size={iconSize()} />
    </div>
  );
};

export default GoalIcon;
